import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState, ListStateItem, ListModuleItem} from '@/store/shared'
import SystemCode from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

interface SystemCodeState extends ListStateItem<SystemCode>{
    editSystemCode:SystemCode;
}
class SystemCodeModule extends ListModuleItem<SystemCodeState,any,SystemCode>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editSystemCode:new SystemCode()
    }

    actions={
        async getAll(context:ActionContext<SystemCodeState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('/services/app/SystemCode/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<SystemCode>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<SystemCodeState,any>,payload:any){
            await $http.post('services/app/SystemCode/Create',payload.data);
        },
        async update(context:ActionContext<SystemCodeState,any>,payload:any){
            await $http.put('services/app/SystemCode/Update',payload.data);
        },
        async delete(context:ActionContext<SystemCodeState,any>,payload:any){
            await $http.post('services/app/SystemCode/DeleteForAudit', payload.data);
        },
        async get(context:ActionContext<SystemCodeState,any>,payload:any){
            let reponse=await $http.get('services/app/SystemCode/Get?Id='+payload.id);
            context.state.editSystemCode = reponse.data.result;
            return reponse.data.result;
        },
    };
    overrideMutations={
        edit(state:SystemCodeState,data:SystemCode){
            state.editSystemCode=data;
        }
    }
}
const systemCodeModule=new SystemCodeModule();
export default systemCodeModule;